type Environment = 'development' | 'acceptance' | 'production';

export const getEnvironment = (): Environment => {
    const { hostname } = window.location;

    if (hostname === 'localhost') {
        return 'development';
    }

    if (['.development.', '-dev-', '-dev.'].some((s) => hostname.includes(s))) {
        return 'development';
    }

    if (['.acceptance.', '-stage-', '-stage.'].some((s) => hostname.includes(s))) {
        return 'acceptance';
    }

    return 'production';
};
